// extracted by mini-css-extract-plugin
export default {"wholeSaleInfo":"info_wholeSaleInfo__evR8q","wholeSaleInfo_section":"info_wholeSaleInfo_section__F4X6H"};